const ro = {
    /**
     * Comments Component
     */
    Comments: 'Comentarii',
    'Write a comment': 'Scrie un comentariu',

    /**
     * Table component
     */
    Loading: 'Se încarcă',
    'No data': 'Nu există date',

    /**
     * Table pagination
     */
    'Rows per page:': 'Rânduri pe pagină:',

    /**
     * Search component
     */
    'Search user': 'Caută utilizator',

    /**
     * Logout modal
     */
    'Are you sure you want to log out?': 'Sunteți sigur că doriți să vă deconectați?',
    YES: 'DA',
    NO: 'NU',

    /**
     * General confirm modal
     */

    'Are you sure you want to perform this action?': 'Sigur doriți să efectuați această acțiune?',
};

export default { ro };
